/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import {Button, Group, Space, Text} from '@mantine/core';
import React, {FC} from 'react';
import HubSpotOnboardingFrame from "../../Atoms/HubSpotOnboardingFrame";
import Contact from "../../Types/Contact";
import {MixpanelS} from "../../Service/MixpanelS";
import {ConstantS} from "../../Service/ConstantS";
import {closeModal, openModal} from "@mantine/modals";
import SkipOnboardingModal from "./SkipOnboardingModal";

const OnboardingCallModal: FC<{
  contact: Contact;
  showDemoSkipButton?: boolean,
  onFinish: () => void;
}> = ({ contact, showDemoSkipButton, onFinish }) => {

  const openSkipOnboardingModal = () =>
    openModal({
      modalId: "skip-onboarding",
      size: 'xl',
      closeOnEscape: false,
      withCloseButton: true,
      transition: 'slide-down',
      children: <SkipOnboardingModal onFinish={onFinish} closeModal={() => {
        closeModal("skip-onboarding");
      }} />,
    });

  return (
    <>
      <Text mt="md" weight="bolder" size={24} align="center" sx={{ lineHeight: 1.2 }}>
        🤗 {`Verschwende keine Zeit mehr` }
      </Text>
      <Space h="md" />
      <Text mb="xs" align="center">
        Wir zeigen Dir, was mit bookitup alles möglich ist und beantworten Deine Fragen.
      </Text>
      <Text size="xs" color="dimmed" align="center">
        Der Termin ist kostenlos und Du kannst ihn jederzeit verschieben oder absagen.
      </Text>

      <Space h="sm" />

      {showDemoSkipButton && <Group mt="xs" mb="xs" position="center">
        <Button
          size="xs"
          mt="md"
          onClick={() => {
            MixpanelS.track(ConstantS.TrackingEvents.SkipOnboardingIntention);
            openSkipOnboardingModal()
          }
          }
        >
          Ohne Demo zur Software
        </Button>
      </Group>}

      <Space h="sm" />
      <HubSpotOnboardingFrame contact={contact} />
    </>
  );
};

export default OnboardingCallModal;
